/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OAuthClientUIConfiguration } from './OAuthClientUIConfiguration';
import {
    OAuthClientUIConfigurationFromJSON,
    OAuthClientUIConfigurationFromJSONTyped,
    OAuthClientUIConfigurationToJSON,
} from './OAuthClientUIConfiguration';

/**
 * 
 * @export
 * @interface PutOauth2UiConfiguration201ResponseAllOf
 */
export interface PutOauth2UiConfiguration201ResponseAllOf {
    /**
     * 
     * @type {OAuthClientUIConfiguration}
     * @memberof PutOauth2UiConfiguration201ResponseAllOf
     */
    result: OAuthClientUIConfiguration;
}

/**
 * Check if a given object implements the PutOauth2UiConfiguration201ResponseAllOf interface.
 */
export function instanceOfPutOauth2UiConfiguration201ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function PutOauth2UiConfiguration201ResponseAllOfFromJSON(json: any): PutOauth2UiConfiguration201ResponseAllOf {
    return PutOauth2UiConfiguration201ResponseAllOfFromJSONTyped(json, false);
}

export function PutOauth2UiConfiguration201ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutOauth2UiConfiguration201ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': OAuthClientUIConfigurationFromJSON(json['result']),
    };
}

export function PutOauth2UiConfiguration201ResponseAllOfToJSON(value?: PutOauth2UiConfiguration201ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': OAuthClientUIConfigurationToJSON(value.result),
    };
}

